import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContractorService {

  constructor(private http: HttpClient) { }


  GetRecord(Token: String): Observable<Array<General_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Contractor?token=" + Token).pipe(
      map(data => {
        return data as Array<General_Interface>
      })
    )
  }


  GetActiveList(Token: String): Observable<Array<General_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Contractor/GetActiveList?token=" + Token).pipe(
      map(data => {
        return data as Array<General_Interface>
      })
    )
  }

  GetSingle(Token: String, id: Number): Observable<General_Interface> {
    return this.http.get(environment.BaseUrl + "Daro/Contractor/GetSingle?token=" + Token + "&id=" + id).pipe(
      map(data => {
        return data as General_Interface
      })
    )
  }

  GetCustomer(Token: String, id: Number): Observable<Array<General_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Contractor/GetCustomer?token=" + Token + "&id=" + id).pipe(
      map(data => {
        return data as Array<General_Interface>
      })
    )
  }

  GetCustomerActiveList(Token: String, id: Number): Observable<Array<General_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Contractor/GetCustomerActiveList?token=" + Token + "&id=" + id).pipe(
      map(data => {
        return data as Array<General_Interface>
      })
    )
  }

  AddContractor(model: General_Interface, Token: String): Observable<General_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id: model.id,
      title: model.title,
      del: false,
      username: Token,
      subdate: null
    }


    return this.http.post(environment.BaseUrl + "Daro/Contractor/Add", body, { headers }).pipe(
      map(data => {
        return data as General_Interface
      })
    )

  }

  EditContractor(model: General_Interface, Token: String): Observable<General_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id: model.id,
      title: model.title,
      del: false,
      username: Token,
      subdate: null
    }


    return this.http.post(environment.BaseUrl + "Daro/Contractor/Edit", body, { headers }).pipe(
      map(data => {
        return data as General_Interface
      })
    )

  }

  DeleteContractor(id: number, Token: String): Observable<General_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/Contractor/Delete?id=" + id + "&token=" + Token).pipe(
      map(data => {
        return data as General_Interface
      })
    )

  }

  DeleteCustomer(id: number, Token: String): Observable<General_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/Contractor/DeleteCustomer?id=" + id + "&token=" + Token).pipe(
      map(data => {
        return data as General_Interface
      })
    )

  }


  AddCustomer(contractor_id: number,customer_id:number,Token:String):Observable<General_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:0,
      contractor_id:contractor_id,
      customer_id:customer_id,
      username:Token,
    }


      return this.http.post(environment.BaseUrl + "Daro/Contractor/AddCustomer",body,{headers}).pipe(
        map(data=>{
          return data as General_Interface
        })
      )

  }

}
